export var UIActionType;
(function (UIActionType) {
    UIActionType["CLOSE_LOADING"] = "CLOSE_LOADING";
    UIActionType["SET_PRIVATE_CHECKED"] = "SET_PRIVATE_CHECKED";
    UIActionType["SHOW_LOADING"] = "SHOW_LOADING";
})(UIActionType || (UIActionType = {}));
